// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBcb_zBvmkR2VL_vkGBXHCZkVsVci9W04E",
    authDomain: "abhyaastrustedu.firebaseapp.com",
    projectId: "abhyaastrustedu",
    storageBucket: "abhyaastrustedu.firebasestorage.app",
    messagingSenderId: "669970641417",
    appId: "1:669970641417:web:dd095f566b5d8124c9fed8",
    measurementId: "G-MTZP2WPR87"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;
